import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import PerfilFormSections from "./PerfilFormSections.js";

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            padre: 0,
            permisos_checked: [],
            permisos_disabled: []
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    }

    ResetForm() {
        this.setState({
            padre: 0,
            permisos_checked: [],
            permisos_disabled: []
        });
    }

    groupChanged(value) {
        this.setState({
            padre: value.pk,
            permisos_disabled: value.permisos
        });
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.usuarios.perfiles.create}
                onSubmit={() => this.props.onSubmit()}
                successMessage={"El Perfil de Usuario ha sido creado con éxito."}
                title={"Nuevo Perfil de Usuario"}
                buttonTitle={"Nuevo Perfil de Usuario"}
                buttonIcon={"fa fa-plus fa-lg"}

                saveButton={true}
                closeButton={true}
                onClose={() => this.ResetForm()}
                className={"ui-modal-dialog ui-modal-lg"}
            >
                <div className="ui-form">
                    <PerfilFormSections
                        autoFocusFirstField={true}
                        padre={this.state.padre}
                        permisosChecked={this.state.permisos_checked}
                        permisosDisabled={this.state.permisos_disabled}
                        onPadreChange={(value) => this.groupChanged(value)}
                        onPermisosChange={(value) => this.setState({ permisos_checked: value })} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Perfiles/Create.js